// extracted by css-extract-rspack-plugin
export default {"modalBody":"W2p_2D9P39M25DWg"};